import { atom } from 'recoil'

export const isOpenDiscardSettingsState = atom({
  key: 'isOpenDiscardEventsSettingsState',
  default: false
})
